
export default function TeamSection() {
  const team = [
    {
      name: 'Musa Tayfun BAŞYİĞİT',
      title: 'Kurucu Ortak Avukat',
      bio: 'Ceza Hukuku, Aile Hukuku, İş Hukuku ve Tazminat Hukuku alanında deneyime sahiptir. Bu kapsamda özellikle boşanma davaları, işçilik alacakları, trafik kazasından kaynaklı bedensel zararların tazmini ve iş kazalarından kaynaklı tazminat davalarıyla ilgilenmektedir.',
      image: 'https://public.readdy.ai/ai/img_res/712c95c9e0724c7fc4b7e776d6d6c5ce.jpg'
    },
    {
      name: 'Hilal Sultan YILDIZ BAŞYİĞİT',
      title: 'Kurucu Ortak Avukat',
      bio: 'Miras Hukuku, Ticaret Hukuku ve Sözleşmeler Hukuku alanında deneyime sahiptir. Özellikle ortaklığın giderilmesi davaları, sözleşmelerin düzenlenmesi ve hazırlanması, şirketlere danışmanlık ile hizmet tespit davaları ile ilgilenmektedir.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Turkish%20female%20lawyer%20in%20dark%20navy%20business%20suit%2C%20confident%20professional%20portrait%2C%20modern%20office%20background%2C%20corporate%20headshot%2C%20sophisticated%20appearance%2C%20clean%20background%2C%20high-quality%20professional%20image&width=300&height=400&seq=lawyer-female&orientation=portrait'
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 animate-fade-in-up">
          <h2 className="text-3xl font-bold text-slate-900 mb-4 font-poppins">
            Ekibimiz
          </h2>
          <div className="w-16 h-0.5 bg-slate-900 mx-auto mb-6"></div>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto font-poppins font-light">
            Deneyimli ve uzman avukat kadromuzla hukuki ihtiyaçlarınızda yanınızdayız
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {team.map((member, index) => (
            <div 
              key={index} 
              className="bg-white rounded-lg shadow-lg overflow-hidden hover-lift animate-fade-in-up"
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <div className="aspect-w-3 aspect-h-4">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-80 object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-slate-900 mb-2 font-poppins">
                  {member.name}
                </h3>
                <p className="text-slate-600 mb-4 font-poppins font-medium">
                  {member.title}
                </p>
                <p className="text-sm text-slate-600 leading-relaxed font-poppins font-light">
                  {member.bio}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
